import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import classNames from 'classnames';

import Page from 'components/ui/page';

import nl2br from 'react-nl2br';
import {api} from 'helpers/api';

import FileReaderInput from 'react-file-reader-input';
import _ from 'lodash';
import Select from 'components/ui/select';
import './feedback.less';
import 'components/ui/popup.less';
import {connect} from "react-redux";
import moment from "moment";
import formats from "dictionaries/formats";
import {Link} from "react-router";
import GlobalLoaderComponent from "components/ui/global-loader";
import {getFaq} from "store/reducers/faq";
import Input from "components/ui/form/input";
import Block from "components/ui/form/block";
import Checkbox from "components/ui/form/checkbox";
import * as alerts from 'helpers/alerts';
import {getCaptcha, sendFeedback} from "store/reducers/feedback";
import InputMask from "components/ui/form/input-mask";

@propTypes({
    onClose: PropTypes.func.isRequired,
})

@connect((state) => ({}), {sendFeedback, getCaptcha})

export default class FeedbackComponent extends Component {

    state = {
        type_of_treatment: 'Обращение',
        title: '',
        body: '',
        full_name: '',
        email: '',
        phone: '',
        files: [],
        confirmed: false,
        errors: {},
        captcha: null,
        captcha_value: '',
    };

    types = [
        'Обращение',
        'Жалоба',
    ];

    componentDidMount() {
        this.getCaptcha();
    }

    async getCaptcha(e) {
        e && e.preventDefault();

        const response = await this.props.getCaptcha();
        if (response.isOk) {
            this.setState({captcha: response.payload});
        } else {
            response.showErrors();
        }
    }

    render() {
        return (
            <div>
                <div key="overlay" className="b-modal__paranja b-modal__paranja_outside"/>
                <div key="modal" className="b-modal b-modal-feedback">
                    <div className="b-modal__header">
                        <div className="b-modal__name">Обратная связь</div>
                        <div className="b-modal__menu">
                            <div className="b-modal__button-block">
                                <div className="b-modal__header-separator"/>
                                <div className="b-modal__header-link _close link-tooltip" onClick={::this.close}>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="b-modal__body">
                        <Block title="Тип обращения">
                            <Select
                                options={_.map(this.types, (type) => ({label: type, value: type}))}
                                value={this.state.type_of_treatment}
                                onChange={::this.onTypeChange}
                                clearable={false}
                                error={this.getError('type_of_treatment')}
                            />
                        </Block>
                        <Block title={<div>Тема обращения <span>*</span></div>}>
                            <Input
                                placeholder="Напишите тему обращения"
                                value={this.state.title}
                                onChange={this.onChange.bind(this, 'title')}
                                error={this.getError('title')}
                            />
                        </Block>
                        <Block size="xl" title={<div>Текст обращения <span>*</span></div>}>
                            <div className="textarea">
                                <textarea
                                    className="textarea__control"
                                    placeholder="Введите текст обращения"
                                    value={this.state.body}
                                    onChange={this.onChange.bind(this, 'body')}
                                />
                                <div
                                    className={classNames('textarea__style', this.getError('body') ? 'input__style_state_wrong' : '')}>
                                    {this.getError('body') ? <span
                                        className="input__style_state_msg input__style_state_msg_wrong">{this.getError('body')}</span> : null}
                                </div>
                                <div className="textarea__attach">
                                    <FileReaderInput as="binary" id="my-file-input" onChange={::this.uploadFile}>
                                        <a className="attach">Добавить файл</a>
                                    </FileReaderInput>

                                    <ul className="textarea__files">
                                        {this.state.files.map((file, index) => (
                                            <li key={index} className="textarea__file">{file.original_filename} <a
                                                href="#"
                                                onClick={this.deleteFile.bind(this, index)}>&times;</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="b-block__desc">Максимальный размер файла 4 мб, максимальное количество не более 10. Допустимые форматы: txt, doc, rtf, xls, pps, ppt, png, tif, gif, bmp, jpeg, pdf</div>
                        </Block>
                        <Block size="xl" title={<div>Ф.И.О. <span>*</span></div>}>
                            <Input
                                placeholder="Введите полное имя"
                                value={this.state.full_name}
                                onChange={this.onChange.bind(this, 'full_name')}
                                error={this.getError('full_name')}
                            />
                        </Block>
                        <Block title={<div>Ваш e-mail <span>*</span></div>}>
                            <Input
                                placeholder="Адрес электронной почты"
                                value={this.state.email}
                                onChange={this.onChange.bind(this, 'email')}
                                error={this.getError('email')}
                            />
                        </Block>
                        <Block title="Ваш телефон">
                            <InputMask
                                placeholder="+7 (код) ххх-хх-хх"
                                value={this.state.phone}
                                onChange={this.onChange.bind(this, 'phone')}
                                error={this.getError('phone')}
                                mask="+7 (999) 999-99-99"
                            />
                        </Block>
                        <Block title="Подтвердите, что вы не робот" nowrap={true}>
                            <div className="b-block__text clearAfter">
                                {this.state.captcha ? (
                                    <div className="captcha" style={{
                                        background: `url(data:image/gif;base64,${this.state.captcha.image}) no-repeat left center`
                                    }}/>
                                ) : null}
                                <a href="#" className="captcha-refresh" onClick={::this.getCaptcha}/>
                            </div>
                        </Block>
                        <Block title="Код подтверждения" nowrap={true}>
                            <Input
                                placeholder="Введите код подтверждения"
                                value={this.state.captcha_value}
                                onChange={this.onChange.bind(this, 'captcha_value')}
                                error={this.getError('captcha.value')}
                            />
                            <div className="b-block__comment">
                                <span>*</span> Поля, обязательные для заполнения
                            </div>
                        </Block>
                        <div className="b-modal__bottom">
                            <Block size="xl">
                                <Checkbox
                                    checked={this.state.confirmed}
                                    onChange={this.onChange.bind(this, 'confirmed')}
                                    label="Настоящим подтверждаю свое
                                            согласие на обработку персональных данных"
                                />
                            </Block>
                        </div>
                        <div className="b-modal__buttons">
                            <button
                                className={classNames('b-button b-button_red b-button_size_md', this.state.confirmed ? 'b-button_shadow_red' : 'b-button_disabled b-button_shadow_gray')}
                                onClick={::this.submit}>Отправить</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    deleteFile(index, e) {
        e.preventDefault();

        let files = this.state.files;
        files.splice(index, 1);
        this.setState({files});
    }

    async submit(e) {
        e.preventDefault();

        if (!this.state.confirmed) {
            alerts.error('Не подтверждено согласие на обработку персональных данных');
            return;
        }

        const response = await this.props.sendFeedback({
            type_of_treatment: this.state.type_of_treatment,
            title: this.state.title,
            body: this.state.body,
            full_name: this.state.full_name,
            email: this.state.email,
            phone: this.state.phone,
            files: this.state.files,
            captcha: {
                uuid: this.state.captcha.uuid,
                value: this.state.captcha_value,
            },
        });
        if (response.isOk) {
            alerts.success('Ваше обращение принято', null, this.props.onClose);
        } else {
            this.setState({
                errors: response.validationErrors
            });
            response.showErrors();
        }
    }

    onChange(field, e) {
        const value = _.get(e, 'target.value');
        let state = this.state;
        _.set(state, field, value);
        this.setState(state);
    }

    onTypeChange(e) {
        const value = e ? e.value : null;
        this.setState({
            type_of_treatment: value,
        });
    }

    close(e) {
        e.preventDefault();

        this.props.onClose();
    }

    async uploadFile(e, results) {
        const tokenInfo = await this.getUploadToken();

        let formData = new FormData();

        results.forEach(result => {
            const [e, file] = result;
            formData.append('file', file);
        });

        formData.append('token', tokenInfo.token);

        try {
            const response = await api.storage.uploadFile(tokenInfo.upload_url, formData);
            let files = this.state.files;
            files.push(response);
            this.setState({files});
        } catch (e) {
            alerts.error('Невозможно загрузить данный файл');
        }
    }

    async getUploadToken() {
        try {
            const response = await api.storage.getUploadToken();
            return response.payload;
        } catch (e) {
            alerts.error('Невозможно загрузить файл');
        }
    }

    getError(field) {
        return _.get(this.state.errors, field);
    }

}


// WEBPACK FOOTER //
// ./src/components/modules/feedback/feedback.js